import React, { useState, useCallback, useEffect, useRef } from 'react';
import { styled } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import SectionSelect, { SectionSelectProps } from '@/pages/project/SectionSelect';

const SectionValue = styled('div')({
  height: '24px',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '0px 7px 0px 14px',
  fontSize: '14px',
  fontWeight: 400,
  border: '1px solid rgba(0, 0, 0, 0.23)',
  borderRadius: '4px',
  boxSizing: 'content-box',
  '&:hover': {
    borderWidth: '2px',
    borderColor: 'rgba(0, 0, 255, 1)',
    padding: '0px 6px 0px 13px',
  }
});

const Label = styled('span')({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

const ArrowIcon = styled(ArrowDropDownIcon)({
  color: 'rgba(0, 0, 0, 0.54)',
})

export default function({ value, ...props }: SectionSelectProps) {
  const [editing, setEditing] = useState(false);

  const editor = useRef<HTMLInputElement>(null);

  const edit = useCallback(() => {
    setEditing(true);
  }, []);

  const display = useCallback(() => {
    setEditing(false);
  }, []);

  const onAutoCompleteReady = useCallback((root: HTMLDivElement) => {
    root.click();
  }, []);

  useEffect(() => {
    if (editor.current) {
      editor.current.focus();
    }
  }, [editor.current]);

  if (editing) {
    return (
      <SectionSelect
        {...props}
        onReady={onAutoCompleteReady}
        inputRef={editor}
        value={value}
        onBlur={display}
        open
    />);
  }
  return <SectionValue onClick={edit}><Label>{value || (<>&nbsp;</>)}</Label><ArrowIcon /></SectionValue>;
}